module.exports = __webpack_public_path__ + "img/高级厨房.5c832ac8.png";